import ImageInputV2 from './image_input_v2';
export default ImageInputV2;
